import classnames from "classnames"
import React from "react"

import "./modal.sass"

export const Modal = ({ shown, children, onClose }) => {
  return (
    <>
      <div
        aria-label={"CLOSE_MODAL"}
        role={"button"}
        className={classnames("_fp-modal-overlay", {
          "_fp-modal-overlay--shown": shown,
        })}
        onKeyDown={() => onClose()}
        onClick={() => onClose()}
      />
      <div className={classnames("_fp-modal", { "_fp-modal--shown": shown })}>
        {children}
      </div>
    </>
  )
}
